import { Button } from '@/components/ui/button';
import { Package } from 'lucide-react';

interface MarketplaceEmptyStateProps {
  readonly type: 'all' | 'free' | 'premium';
  readonly searchQuery?: string;
  readonly onReset: () => void;
}

export function MarketplaceEmptyState({ 
  type,
  searchQuery,
  onReset 
}: Readonly<MarketplaceEmptyStateProps>) {
  const content = {
    all: {
      title: 'No Decks Found',
      description: searchQuery 
        ? 'No decks match your current filters. Try adjusting your search or filter settings.'
        : 'No decks are currently available in the marketplace.',
    },
    free: {
      title: 'No Free Decks Found',
      description: 'No free decks match your current filters. Try adjusting your search or filter settings.',
    },
    premium: {
      title: 'No Premium Decks Found',
      description: 'No premium decks match your current filters. Try adjusting your search or filter settings.',
    }
  };

  return (
    <div className="bg-black/60 backdrop-blur-sm rounded-xl border border-primary/30 p-8 text-center">
      <Package className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
      <h3 className="text-lg font-medium mb-2">{content[type].title}</h3>
      <p className="text-muted-foreground mb-4">
        {content[type].description}
      </p>
      <Button
        onClick={onReset}
        className="bg-red-600 hover:bg-red-700 text-white shadow-md border-0 font-medium"
      >
        Reset Filters
      </Button>
    </div>
  );
}